import Pagination from './pagination'
export default Pagination
